export default ({ app }, inject) => {
  // Inject $hello(msg) in Vue, context and store.

  let options = {
      timeZone: app.store.getters['user/getUserIP'].timezone,
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      timeZoneName: 'short',
    },
    dateOptions = {
      timeZone: app.store.getters['user/getUserIP'].timezone,
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      timeZoneName: 'short',
    },
    timeOptions = {
      timeZone: app.store.getters['user/getUserIP'].timezone,
      hour: 'numeric',
      minute: 'numeric',
      timeZoneName: 'short',
    },
    formatter = new Intl.DateTimeFormat(app.i18n.locale, options),
    formatterTime = new Intl.DateTimeFormat(app.i18n.locale, timeOptions),
    formatterDate = new Intl.DateTimeFormat(app.i18n.locale, dateOptions)

  const parseDate = (date, gmt = '+03:00') => {
    if (date === null || date === undefined || date === '') return null

    if (date instanceof Date) {
      return Number.isFinite(date.getTime()) ? date : null
    }

    if (typeof date === 'number') {
      return Number.isFinite(date) ? new Date(date) : null
    }

    const dateStr = String(date).trim()
    if (!dateStr) return null

    // Zaten timezone bilgisi varsa gmt ekleme (Safari'de çift offset invalid date üretir)
    if (/[zZ]$|[+-]\d{2}(:\d{2})?$/.test(dateStr)) {
      const parsed = new Date(dateStr)
      return Number.isFinite(parsed.getTime()) ? parsed : null
    }

    const parsed = new Date(`${dateStr}${gmt}`)
    return Number.isFinite(parsed.getTime()) ? parsed : null
  }

  const safeFormat = (intlFormatter, date, gmt = '+03:00') => {
    const parsed = parseDate(date, gmt)
    if (!parsed) return ''
    try {
      return intlFormatter.format(parsed)
    } catch {
      return ''
    }
  }

  // date format 2023-01-01T20:00:00
  inject('date', {
    format: (date, gmt = '+03:00') => safeFormat(formatter, date, gmt),
    formatOnlyTime: (date, gmt = '+03:00') =>
      safeFormat(formatterTime, date, gmt),
    formatOnlyDate: (date, gmt = '+03:00') =>
      safeFormat(formatterDate, date, gmt),
    formatToParts: (date, gmt = '+03:00') => {
      const parsed = parseDate(date, gmt)
      if (!parsed) return []
      try {
        return formatter.formatToParts(parsed)
      } catch {
        return []
      }
    },
    getTimeWithoutOffset: (date, gmt = '+03:00') => {
      const parsed = parseDate(date, gmt)
      if (!parsed) return NaN
      const resetOffset = new Date().getTimezoneOffset() * 60 * 1000 // bölgenin offseti
      const offset =
        app.store.getters['user/getUserIP'].offset === 1
          ? 0
          : app.store.getters['user/getUserIP'].offset * 1000
      const d = parsed.getTime()
      const remainOffset = resetOffset + offset // burası 0 çıkmalı kullanıcının offseti ile konumun offseti hesaplanır
      return d - remainOffset
      // 20:00 - (00:00) + (-03:00); = 17:00
      // 17:00 - (-03:00) + (-00:00); = 17:00
    },
    formatWithDuration: (date, duration, gmt = '+03:00') => {
      const parsed = parseDate(date, gmt)
      if (!parsed) return ''
      const end = new Date(parsed.getTime() + duration * 60000)
      if (!Number.isFinite(end.getTime())) return ''
      try {
        return formatterTime.format(end)
      } catch {
        return ''
      }
    },
  })
}
